import React from "react";

export default function TableWidget({ title, columns, data }) {
  const defaultColumns = [
    { key: "timestamp", label: "Zaman" },
    { key: "metric", label: "Metrik" },
    { key: "value", label: "Değer" },
    { key: "status", label: "Durum" },
  ];

  const defaultData = [
    { timestamp: "12:45:30", metric: "Temperature", value: "54.8 °C", status: "Normal" },
    { timestamp: "12:45:25", metric: "Vibration", value: "25.5 mm/s", status: "Normal" },
    { timestamp: "12:45:20", metric: "Pressure", value: "104 kPa", status: "Warning" },
    { timestamp: "12:45:15", metric: "Voltage", value: "223 V", status: "Normal" },
    { timestamp: "12:45:10", metric: "Current", value: "11.8 A", status: "Normal" },
  ];

  const cols = columns || defaultColumns;
  const rows = data || defaultData;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "normal":
      case "ok":
        return "#4caf50";
      case "warning":
        return "#ff9800";
      case "error":
      case "critical":
        return "#f44336";
      default:
        return "#8b949e";
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>{title}</span>
      </div>
      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              {cols.map((col) => (
                <th key={col.key} style={styles.th}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx} style={styles.tr}>
                {cols.map((col) => (
                  <td
                    key={col.key}
                    style={{
                      ...styles.td,
                      color: col.key === "status" ? getStatusColor(row[col.key]) : "#e6edf3",
                    }}
                  >
                    {row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#161b22",
    borderRadius: "8px",
    padding: "8px 10px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    marginBottom: "4px",
  },
  title: {
    color: "#e6edf3",
    fontSize: "12px",
    fontWeight: "500",
  },
  tableWrapper: {
    flex: 1,
    overflow: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "11px",
  },
  th: {
    textAlign: "left",
    padding: "4px 8px",
    color: "#8b949e",
    fontWeight: "500",
    borderBottom: "1px solid #30363d",
    whiteSpace: "nowrap",
  },
  tr: {
    borderBottom: "1px solid #21262d",
  },
  td: {
    padding: "4px 8px",
    color: "#e6edf3",
    whiteSpace: "nowrap",
  },
};
